module.exports = __webpack_public_path__ + "media/warriors-ft-imagine-dragons-worlds-2014-league-of-legends.2b43f6e6.mp3";